import React, { memo } from 'react';
import Button3 from './Button3/Button3';
import ButtonPay from './ButtonPay/ButtonPay';
import ButtonHardware from './ButtonHardware/ButtonHardware';

export default memo(
  ({
    soft,
    info = {},
    logInfo = {},
    clickCallbackTag = false,
    reductionTag = () => {},
    hoverTag = false,
  }) => {
    return (
      <>
        {soft?.type === 3 && (
          <ButtonPay
            soft={soft}
            info={info}
            logInfo={logInfo}
            clickCallbackTag={clickCallbackTag}
            reductionTag={reductionTag}
            hoverTag={hoverTag}
          />
        )}
        {soft?.type === 1 && (
          <Button3
            soft={soft}
            info={info}
            logInfo={logInfo}
            clickCallbackTag={clickCallbackTag}
            reductionTag={reductionTag}
            hoverTag={hoverTag}
          />
        )}
        {[2, 4].includes(soft?.type) && (
          <ButtonHardware
            soft={soft}
            info={info}
            logInfo={logInfo}
            clickCallbackTag={clickCallbackTag}
            reductionTag={reductionTag}
            hoverTag={hoverTag}
          />
        )}
      </>
    );
  },
);
